import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(timezone)

export const getOffsetTime = offset => {
    if (offset) {
        return offset.replace('UTC', '')
    }
    const date = dayjs().format()
    const m = date.includes('+') ? date.split('+') : date.split('-')
    return (date.includes('+') ? '+' : '-') + m[m.length - 1]
}

export const getTimezoneOffset = timezone => {
    const diff = dayjs().tz(timezone.toString()).utcOffset()
    let hourDiff: any = Math.floor(diff / 60)
    let minuteDiff: any = Math.floor(diff % 60)
    const hourNumber = Math.abs(hourDiff)
    const minuteNumber = Math.abs(minuteDiff)
    if (hourNumber.toString().length === 1) {
        hourDiff = (hourDiff.toString().includes('-') ? '-0' : '0') + hourNumber.toString()
    }
    if (minuteDiff === 0) {
        minuteDiff = '00'
    }

    const value =
        'UTC' +
        (hourNumber !== 0 || minuteNumber !== 0
            ? (hourDiff > 0 ? '+' : hourDiff === 0 && minuteDiff < 0 ? '-' : '') +
              hourDiff.toString() +
              ':' +
              (minuteNumber === 0 ? minuteDiff : minuteNumber.toString())
            : '')
    return value
}

export const getOffsetFromTimezone = timeShift => {
    const timezone = timeShift || getTimezoneOffset(dayjs.tz.guess())
    const modifier: any = timezone.replace('UTC', '').split(':')
    const offset = modifier[0] * 60 + (modifier[0].includes('-') ? 0 - Number(modifier[1]) : Number(modifier[1]))
    return offset || 0
}

export const getTimeStampsAsOffset = (timestamps, offset, oldOffsetTime) => {
    const newTimeStamps = []
    const format = 'YYYY-MM-DD hh:mm AZ'
    const now = dayjs().utcOffset(offset)

    let offsetTime = (oldOffsetTime ? oldOffsetTime : getTimezoneOffset(dayjs.tz.guess())).replace('UTC', '')
    if (!offsetTime) {
        offsetTime = '+00:00'
    }
    timestamps
        .filter(item => item.date && item.startTime && item.endTime)
        .sort((a, b) => {
            const getTime = item => {
                const dateString = item.date.format()
                const date = dateString.substring(0, 10)
                const time = dayjs(date + 'T' + item.startTime.format('HH:mm:ss') + offsetTime, format).utc()
                return time.format()
            }
            return getTime(a).localeCompare(getTime(b))
        })
        .forEach(item => {
            const dateString = item.date.format()
            const date = dateString.substring(0, 10)

            const utcStartTime = dayjs(date + 'T' + item.startTime.format('HH:mm:ss') + offsetTime, format).utc()
            const newStartTime = dayjs(utcStartTime, format).utcOffset(offset)
            let utcEndTime = dayjs(item.endTime.format('YYYY-MM-DDTHH:mm:ss') + offsetTime, format).utc()
            if (!item.endTime.format().includes(offsetTime) || !item.endTime.format().includes(date)) {
                utcEndTime = dayjs(date + 'T' + item.endTime.format('HH:mm:ss') + offsetTime, format).utc()
            }
            const newEndTime = dayjs(utcEndTime, format).utcOffset(offset)
            // console.log('from===========', item.startTime.format(), item.endTime.format())
            // console.log('to===========', newStartTime.format(), newEndTime.format())
            // console.log('----------------------------------------------')
            const diffDay = newEndTime.diff(newStartTime, 'day', true)
            let lastEndTime: any = ''
            let lastIndex = -1
            if (newTimeStamps.length) {
                lastIndex = newTimeStamps.length - 1
                const lastItem = newTimeStamps[lastIndex]
                const dateString = lastItem.date.format()
                const date = dateString.substring(0, 10)
                let lastOffsetTime = dateString.substring(dateString.length - 6)
                if (lastOffsetTime.includes('Z')) {
                    lastOffsetTime = '+00:00'
                }
                const utcEndTime = dayjs(
                    date + 'T' + lastItem.endTime.format('HH:mm:ss') + lastOffsetTime,
                    format
                ).utc()
                lastEndTime = dayjs(utcEndTime, format).utcOffset(offset)
            }
            if (
                newStartTime.isSame(newEndTime, 'day') ||
                (diffDay > 0 && diffDay <= 1 && newEndTime.format().includes('T00:00'))
            ) {
                if (lastEndTime && lastEndTime?.isSame(newStartTime)) {
                    newTimeStamps[lastIndex].endTime = newEndTime
                    newTimeStamps[lastIndex].disabledEndDate = now.diff(newEndTime, 'minutes') > 0
                } else {
                    newTimeStamps.push({
                        startTime: newStartTime,
                        endTime: newEndTime,
                        date: newStartTime,
                        disabled: now.diff(newStartTime, 'minutes') > 0,
                        disabledEndDate: now.diff(newEndTime, 'minutes') > 0
                    })
                }
            } else {
                const endTime = dayjs(newEndTime, format).set('hour', 0).set('minute', 0)
                if (lastEndTime && lastEndTime?.isSame(newStartTime)) {
                    newTimeStamps[lastIndex].endTime = endTime
                    newTimeStamps[lastIndex].disabledEndDate = now.diff(endTime, 'minutes') > 0
                } else {
                    if (!newStartTime.isSame(endTime)) {
                        newTimeStamps.push({
                            startTime: newStartTime,
                            endTime,
                            date: newStartTime,
                            disabled: now.diff(newStartTime, 'minutes') > 0,
                            disabledEndDate: now.diff(endTime, 'minutes') > 0
                        })
                    }
                }

                const startTime = dayjs(newEndTime, format).set('hour', 0).set('minute', 0)
                if (!startTime.isSame(newEndTime)) {
                    newTimeStamps.push({
                        startTime: startTime,
                        endTime: newEndTime,
                        date: newEndTime,
                        disabled: now.diff(startTime, 'minutes') > 0,
                        disabledEndDate: now.diff(newEndTime, 'minutes') > 0
                    })
                }
            }
        })
    return newTimeStamps
}
